import React, { useState } from "react";

import { showToast } from "../../utils/utils";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import { useNavigate } from "react-router-dom";
import "./smstemplate.scss";
import {
  alertActions,
  commonErrMsg,
  createSmstemp,
  editEmailTemp,
  fieldValidation,
  smsTemplate,
  tooltips
} from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import privateAxios from "../../utils/axiosPrivate";
import { getsmsTemplateURL } from "../../utils/constants/apiEndPoints";
import { SMS_TEMPLATES } from "../../route/paths";

const CreateSmsTemplate = () => {
  const navigate = useNavigate();
  const [templateName, setTemplateName] = useState("");
  const [description, setDescription] = useState("");
  const [smsContent, setSmsContent] = useState("");

  const [templateNameError, setTemplateNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [smsContentError, setSmsContentError] = useState("");

  const handleTemplateNameChange = (e) => {
    setTemplateName(e.target.value);
    setTemplateNameError("");
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
    setDescriptionError("");
  };

  const handleSmsChange = (e) => {
    setSmsContent(e.target.value);
    setSmsContentError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    if (!templateName) {
      setTemplateNameError(fieldValidation.required);
      isValid = false;
    }
    if (!description) {
      setDescriptionError(fieldValidation.required);
      isValid = false;
    }
    if (!smsContent) {
      setSmsContentError(fieldValidation.required);
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    try {
      const updatedSmsTemplate = {
        templateName: templateName,
        triggerDescription: description,
        smsContent: smsContent,
        isActive: true,
        isDynamic: true,
        templateCategory: smsTemplate.userTriggered
      };

      const response = await privateAxios.post(
        getsmsTemplateURL,
        updatedSmsTemplate
      );
      navigate(SMS_TEMPLATES);
      showToast(response.data.message, showToastType.success);
    } catch (error) {
      if (error.response?.status === 409) {
        const errors = error.response.data.errors;
        const detailedMessage =
          errors && errors.length
            ? errors.join(", ")
            : createSmstemp.errMsg.item1;
        showToast(detailedMessage, showToastType.error);
      } else {
        const errorMessage =
          error.response?.data?.message || commonErrMsg.item4;
        showToast(errorMessage, showToastType.error);
      }
    }
  };

  const handleRest = (e) => {
    e.preventDefault();
    setTemplateName("");
    setDescription("");
    setSmsContent("");
    setTemplateNameError("");
    setDescriptionError("");
    setSmsContentError("");
  };

  const handleCancel = () => {
    navigate(SMS_TEMPLATES);
  };

  const listItems = [
    "{{$owner_first_name}}",
    "{{$customer_name}}",
    "{{$FT_user_preferred_name}}",
    "{{$FT_AU_phone_number}}",
    "{{$FT_NZ_phone_number}}",
    "{{$Rick_AU_phone_number}}",
    "{{$Rick_NZ_phone_number}}",
    "{{$FT_user_phone_number_NZ_or_AU}}",
    "{{$FT_AU_bank_account_number}}",
    "{{$FT_NZ_bank_account_number}}",
    "{{$to_fund_page_link}}",
    "{{$funded_page_link}}",
    "{{$finish_signing_up_page_link}}"
  ];

  return (
    <>
      <TablePagesTitle
        mainTitle={smsTemplate.mainTitle}
        content={smsTemplate.createBtn}
      />
      <AccessPageAction subheading={createSmstemp.creteTemp} />
      <div className="row mt-3">
        <div className="col-md-4 col-lg-3">
          <div className="dynamic-content-section mb-3">
            <label htmlFor="dymicContent">
              <strong>{editEmailTemp.dymicContent}</strong>
            </label>
            <div className="mt-2">
              <ul className="ms-5 template-list">
                {listItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="templateName">
              <strong>{editEmailTemp.templateName}</strong>
            </label>
            <input
              type="text"
              placeholder={createSmstemp.templatePlaceholder}
              name="name"
              value={templateName}
              onChange={handleTemplateNameChange}
            />
            {templateNameError && (
              <p className="error-message text-danger">
                <small>{templateNameError}</small>
              </p>
            )}
          </div>
          <div className="input-group-wrap mb-2">
            <label className="mb-1" htmlFor="triggerDescription">
              <strong>{editEmailTemp.triggerDescription}</strong>
            </label>
            <textarea
              name="description"
              placeholder={editEmailTemp.triggerDescription}
              value={description}
              onChange={handleDescriptionChange}
            />
            {descriptionError && (
              <p className="error-message text-danger">
                <small>{descriptionError}</small>
              </p>
            )}
          </div>
        </div>
        <div className="col-md-8 col-lg-9">
          <div className="preview-section mb-3">
            <div className="title-area border-bottom mb-3">
              <h2>{editEmailTemp.templatePreview}</h2>
            </div>
            <div className="preview-box">
              {smsContent || createSmstemp.smsContent}
            </div>
          </div>
          <div className="input-group-wrap mb-2">
            <textarea
              name="sms_content"
              placeholder={createSmstemp.templatePreview}
              id="sms-content"
              value={smsContent}
              onChange={handleSmsChange}
            />
            {smsContentError && (
              <p className="error-message text-danger">
                <small>{smsContentError}</small>
              </p>
            )}
          </div>
        </div>
        <div className="col-md-8 col-lg-9 offset-md-4 offset-lg-3">
          <div className="created-buttongroup d-flex">
            <button
              type="submit"
              className="btn btn-primary me-2"
              onClick={handleSubmit}
            >
              {smsTemplate.createBtn}
            </button>
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={handleRest}
            >
              {tooltips.reset}
            </button>
            <button
              type="button"
              className="btn btn-secondary btn-red"
              onClick={handleCancel}
            >
              {alertActions.Cancel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateSmsTemplate;
